export const tokenKinds = [
  {
    label: "eventForm:zapier.beta",
    kind: "zapier-token",
  },
];
